// src/components/sections/TestimonialsSection.js
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { fetchFeaturedTestimonials } from '../../services/api';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeader, ErrorBox, StarRating, Avatar } from '../ui';
import styles from './TestimonialsSection.module.css';

function TestimonialCard({ item }) {
  const { t, ui } = useLang();
  return (
    <div className={`${styles.card} card`}>
      <StarRating rating={item.rating} />
      <p className={styles.text}>«{t(item, 'text')}»</p>
      <div className={styles.author}>
        <Avatar name={item.avatar_initial || item.name} color={item.avatar_color} size={40} />
        <div>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.city}>{t(item, 'city')}</div>
        </div>
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  const { ui } = useLang();
  const { data: items = [], isLoading, isError, refetch } = useQuery(
    'featuredTestimonials',
    fetchFeaturedTestimonials,
    { staleTime: 1000 * 60 * 10 }
  );

  return (
    <section className={styles.section} id="testimonials">
      <SectionHeader
        badge={ui('✦ رضایت‌مندی مشتریان', '✦ Customer Reviews')}
        title={ui('مشتریان ما چه می‌گویند', 'What Our Customers Say')}
      />

      {isError && <ErrorBox onRetry={refetch} />}

      {isLoading ? (
        <div className={styles.track}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton" style={{ height: 200, minWidth: 280, borderRadius: 'var(--radius-lg)' }} />
          ))}
        </div>
      ) : (
        <div className={styles.track}>
          {items.map((item) => (
            <TestimonialCard key={item.id} item={item} />
          ))}
        </div>
      )}

      <div className={styles.more}>
        <Link to="/testimonials" className="btn-secondary">
          {ui('مشاهده همه نظرات ←', 'View All Reviews ←')}
        </Link>
      </div>
    </section>
  );
}
